<!--{{profileForm.valid | json}}-->
<!--<form  [formGroup]="profileForm" *ngIf="profileForm" (ngSubmit)="isOnlyMember ? openSurveyOrPayment() :  updateClient()">-->
@if (profileForm) {
  <form  [formGroup]="profileForm" (ngSubmit)="updateClient()">
    @if (!clientService.isLoggedInFromSession) {
      <div formGroupName="client" class="tw-flex tw-row-2" style="justify-content: center">
        <mat-form-field class="tw-input-width" appearance="outline" style="margin: 0 20px">
          <mat-label>{{'client.firstName' | translate}}</mat-label>
          <input matInput  required formControlName="firstname"
            autocomplete='given-name'>
          <!--            <mat-error>-->
          <!--                <tw-form-error-message [errors]="clientGroup.controls['firstname'].errors"></tw-form-error-message>-->
        <!--            </mat-error>-->
      </mat-form-field>
      <mat-form-field  class="tw-input-width" appearance="outline" style="margin: 0 20px">
        <mat-label>{{'client.lastName' | translate}}</mat-label>
        <input matInput required
          formControlName="lastname" autocomplete='family-name' >
        <!--            <mat-error>-->
        <!--                <tw-form-error-message [errors]="clientGroup.controls['lastname'].errors"></tw-form-error-message>-->
      <!--            </mat-error>-->
    </mat-form-field>
  </div>
}
<div >
  <tw-address [formGroupAddress]="addressGroup" [address]="address" (addressChange)="countryChange($event)"></tw-address>
</div>
<div >
  <tw-phone-form [formGroupPhone]="phoneGroup" [phone]="phone"></tw-phone-form>
</div>
<div class="tw-flex tw-row-reverse">
  <button
    mat-raised-button
    color="primary"
    type="submit"
    class="tw-primary"
        > {{isOnlyMember? ("title.next" | translate) : ("shipping.shippingMode" | translate)}}  <span style="font-weight: 900;
    margin-left: 10px;"> > </span>
  <!--            {{ "formMsg.submit" | translate }}-->
  @if (!load) {
    <div class="cssload-speeding-wheel"></div>
  }
</button>
</div>
</form>
}


